import { DEFAULT_VALUE } from "@supplier/constants";

/**
 * 格式化数字显示 1234.1 => 1,234.1
 * @param number 数字
 * @param decimal 保留小数位数
 * @param divisor 分母
 */
export function formatNumber(number: number | string, decimal?: number, divisor?: number) {
    if (typeof number !== "number") return DEFAULT_VALUE;
    let f = "";
    if (number < 0) {
        f = "-";
        number = -number;
    }
    if (divisor) {
        number = number / divisor;
        if (number < 0.01) {
            number = 0.01;
        }
    }
    // 将数字转换为字符串
    const numStr = number.toString();

    // 分割整数部分和小数部分
    const parts = numStr.split(".");
    const integerPart = parts[0];
    let decimalPart = parts[1] || "";

    // 对整数部分进行逗号分隔
    let formattedInteger = "";
    let i;
    let j = 1;
    for (i = integerPart.length - 1, j; i >= 0; i--, j++) {
        formattedInteger = integerPart[i] + formattedInteger;
        if (j > 0 && j % 3 === 0) {
            formattedInteger = `,${formattedInteger}`;
        }
    }
    if (formattedInteger[0] === ",") {
        formattedInteger = formattedInteger.slice(1);
    }
    // 如果不需要格式化小数部分，直接返回整数部分
    if (!decimal) {
        return formattedInteger;
    }
    // 拼接整数部分和小数部分
    decimalPart = Number.parseFloat(`0.${decimalPart || 0}`)
        .toFixed(2)
        .slice(1);
    return f + formattedInteger + decimalPart;
}

/**
 * 解析输入的数字
 * @param value 输入的值
 */
export const parserInputNumber = (value: string) => {
    return value.replace(/[^0-9.]/g, "").replace(/(\.\d{2})\d*/, "$1");
};

// 将数字转换为中文数字
export const numberToChinese = (num: number): string => {
    const units = ["", "十", "百", "千", "万", "十", "百", "千", "亿"];
    const chars = ["零", "一", "二", "三", "四", "五", "六", "七", "八", "九"];
    const numStr = num.toString();
    let result = "";
    let zeroCount = 0;

    for (let i = 0; i < numStr.length; i++) {
        const n = Number.parseInt(numStr[i]);
        const unitIndex = numStr.length - i - 1;

        if (n === 0) {
            zeroCount++;
        } else {
            if (zeroCount > 0) {
                result += chars[0];
            }
            zeroCount = 0;
            result += chars[n] + units[unitIndex];
        }
    }

    return result.replace(/一十/g, "十");
};

// 四舍五入 decimal 保留的小数位数
export const roundOff = (num: number, decimal: number = 0) => {
    if (!num) {
        return num;
    }
    const pow = 10 ** decimal;
    let res = Math.round(num * pow) / pow;
    res = +res.toFixed(decimal);
    return res;
};

/**
 * 判断字符串数字是正数还是负数
 * @param numStr 字符串数字
 * @returns -1: 负数, 0: 零, 1: 正数
 */
export const judgeNumberSign = (numStr: string | number | undefined | null): -1 | 0 | 1 => {
    // 检查输入是否为undefined或null
    if (numStr === undefined || numStr === null) {
        return 0; // 或者根据需求返回其他默认值
    }

    // 将输入转换为字符串
    let cleanedStr: string;
    if (typeof numStr === "string") {
        // 移除字符串中的逗号等千位分隔符
        cleanedStr = numStr.replace(/,/g, "");
    } else {
        // 如果已经是数字类型，直接转换为字符串
        cleanedStr = String(numStr);
    }

    // 尝试将字符串转换为数字
    const num = Number(cleanedStr);

    // 检查是否为有效数字
    if (Number.isNaN(num)) {
        return 1;
    }

    // 判断符号
    if (num < 0) {
        return -1;
    } else if (num > 0) {
        return 1;
    } else {
        return 0;
    }
};
